export function normalizeThaiMobile(value: string) {
  return value.replace(/[\s-]/g, "");
}

export function isValidThaiMobile(value: string) {
  return /^0[689]\d{8}$/.test(normalizeThaiMobile(value));
}
